import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  // upload kba
  uploadKba(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbanadjustupload/uploadkba', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  uploadKbaFactor(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbanadjustupload/uploadkbafactor', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  // set cycle
  getKbaTempList(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbanadjustupload/kbatemplist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getCycleList(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbanadjustupload/cyclelist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getKbaCycleList(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbanadjustupload/kbacyclelist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  setKbaCycleList(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbanadjustupload/setkbacyclelist', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  createKba(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbanadjustupload/createkba', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  createKbaFactor(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbanadjustupload/createkbafactor', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/KanbanAdjustUpload.js